import { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { AuditlogData, ManufacturerDetailsData, ProductDetailsData, ProductsApplicationDetailsData } from "./data/ProductsApplicationDetails.data";
import Accordion from "../../components/Accordion/Accordion";
import { Button } from "react-bootstrap";
import Select from "react-select";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { AuditlogConfig } from "./data/AuditlogConfig";
import CenterModel from "../../components/ui/centerModel/CenterModel";



const ProductsApplicationDetails = () => {
  const MemberApplicationRef = useRef();
  const [formData, setFormData] = useState(ProductsApplicationDetailsData);
  const AuditlogRef = useRef();
  const [AuditlogRefData, setAuditlogData] = useState(AuditlogData);
  const molGridRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openCloseModal = () => {
    setIsModalOpen(!isModalOpen);
    // getMemberList( paginationRequest );
  };

  const openModal = () => {
    setIsModalOpen(!isModalOpen);
    // getMemberList( paginationRequest );
  };

  return (
    <div className="products-application-details-page">
      <div className="d-flex gap-3 mb-4 justify-content-end">
        <Buttons
          buttonText="Audit Log"
          buttonTypeClassName="success-btn"
          onClick={openModal}
        // isLoading={isChangeKeyPosition}
        // isDisable={isChangeKeyPosition}
        />
      </div>
      <div className="application-information">
        <Accordion
          title="Application Information"
          className="mb-4"
          button={false}
          // buttonLabel="Audit Log"
          accordion={true}
        >
          <div className="row">
            <FormCreator
              ref={MemberApplicationRef}
              {...formData}
            />
          </div>
        </Accordion>
      </div>

      <Accordion
        title="Self Evaluation Information"
        className="mb-4"
        button={false}
        accordion={true}
      >
        <div className="self-evaluation-page">
          {/* SECTION A */}
          <div className="section-card mb-0 pb-0">
            <h3 className="section-title">Section A</h3>
            <div className="evaluation-table-wrapper">
              <div className="evaluation-table">
                <div className="table-header">
                  <div>1. Requirement 1 Title</div>
                  <div>Documents to Upload</div>
                  <div>Submission</div>
                </div>

                <div className="table-body">
                  <div className="column">
                    <p>Title in the content</p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur tempor, magna vel auctor ultricies, tortor nibh
                      fermentum lectus, sed eleifend orci lacus vel justo. Proin
                      suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                    </p>
                    <p>
                      Example of links here: Click{" "}
                      <a className="link" href="#">
                        here
                      </a>{" "}
                      to see more information
                    </p>
                  </div>

                  <div className="column">
                    <p>Title in the content</p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur tempor, magna vel auctor ultricies, tortor nibh
                      fermentum lectus, sed eleifend orci lacus vel justo. Proin
                      suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                    </p>
                    <p>
                      Example of links here: Click{" "}
                      <a className="link" href="#">
                        here
                      </a>{" "}
                      to see more information
                    </p>
                  </div>

                  <div className="column submission">
                    <button className="upload-btn btn outline-btn">Upload</button>

                    <div className="files">
                      <p>
                        <b>File Uploaded</b>
                      </p>
                      <p>
                        abc.xls <span>Delete</span>
                      </p>
                      <p>
                        def.xls <span>Delete</span>
                      </p>
                    </div>
                    <label>Comment</label>
                    <textarea disabled placeholder=""></textarea>
                  </div>
                </div>

                <div className="status-bar">
                  <span>Status</span>
                  <span>Approved</span>
                  <span></span>
                </div>
                <div className="commant-box">
                  <label className="mb-2">Peer Reviewer/Final Approver Comments (Internal)</label>
                  <textarea placeholder="SGBC Comments"></textarea>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION B */}

          <div className="section-card mb-0 pb-0">
            <h3 className="section-title">Section B</h3>
            <div className="evaluation-table-wrapper">
              <div className="evaluation-table">
                <div className="table-header">
                  <div>1. Requirement 1 Title</div>
                  <div>Documents to Upload</div>
                  <div>Submission</div>
                </div>
                <div className="table-body">
                  <div className="column">
                    <p>Title in the content</p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur tempor, magna vel auctor ultricies, tortor nibh
                      fermentum lectus, sed eleifend orci lacus vel justo. Proin
                      suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                    </p>
                    <p>
                      Example of links here: Click{" "}
                      <a className="link" href="#">
                        here
                      </a>{" "}
                      to see more information
                    </p>
                  </div>

                  <div className="column">
                    <p>Title in the content</p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur tempor, magna vel auctor ultricies, tortor nibh
                      fermentum lectus, sed eleifend orci lacus vel justo. Proin
                      suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                    </p>
                    <p>
                      Example of links here: Click{" "}
                      <a className="link" href="#">
                        here
                      </a>{" "}
                      to see more information
                    </p>
                  </div>

                  <div className="column submission">
                    <button className="upload-btn btn outline-btn">Upload</button>

                    <div className="files">
                      <p>
                        <b>File Uploaded</b>
                      </p>

                      <p>
                        abc.xls <span>Delete</span>
                      </p>
                      <p>
                        def.xls <span>Delete</span>
                      </p>
                    </div>

                    <label>Comment</label>
                    <textarea disabled placeholder=""></textarea>
                  </div>

                  <div className="row">
                    {/* BLOCK 1 */}
                    <div className="form-block">
                      <div className="left">
                        <label>Label</label>
                        <label className="mt-5">Instruction</label>
                      </div>
                      <div className="right">
                        <input type="text" placeholder="Textbox" />
                        <textarea disabled placeholder="Comments"></textarea>
                      </div>
                    </div>

                    <div className="divider"></div>

                    {/* BLOCK 2 */}
                    <div className="form-block">
                      <div className="left">
                        <label>
                          Label <span className="red-star">*</span>
                        </label>
                        <label className="mt-5">Instruction</label>
                      </div>
                      <div className="right">
                        <Select
                          className="custom-checkbox-select"
                        // value={props.value}
                        // value={""} /
                        // options={Options}

                        // onChange={props.onChange}
                        // onBlur={props.onBlur}
                        // options={props.options}
                        // isMulti={props.isMultiSelect}
                        // placeholder={props.placeholder}
                        // isDisabled={true}
                        />
                        <textarea disabled placeholder="Comments"></textarea>
                      </div>
                    </div>

                    <div className="divider"></div>

                    {/* BLOCK 3 */}
                    <div className="form-block">
                      <div className="left">
                        <label>Label</label>
                        <label className="mt-5">Instruction</label>
                      </div>
                      <div className="right">
                        <Select
                          className="custom-checkbox-select"
                          placeholder="Tick Rating"
                        // value={props.value}
                        // value={""} /
                        // options={Options}

                        // onChange={props.onChange}
                        // onBlur={props.onBlur}
                        // options={props.options}
                        // isMulti={props.isMultiSelect}
                        // placeholder={props.placeholder}
                        // isDisabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="status-bar">
                  <span>Status</span>
                  <span>Approved</span>
                </div>
                <div className="commant-box">
                  <label>Peer Reviewer/Final Approver Comments (Internal)</label>
                  <textarea></textarea>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION C */}

          <div className="section-card mb-0 pb-0">
            <h3 className="section-title">Section C</h3>

            <div className="rating-box">
              <h4>Section C Additional Information</h4>

              <table className="rating-table">
                <tbody>
                  <tr>
                    <td>1 Tick</td>
                    <td>
                      <span>
                        {" "}
                        <input disabled className="change-value"></input>/ 6
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>2 Tick</td>
                    <td>
                      <span>
                        <input disabled className="change-value"></input>/ 6
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>3 Tick</td>
                    <td>
                      <span>
                        <input disabled className="change-value"></input>/ 6
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>4 Tick</td>
                    <td>
                      <span>
                        <input disabled className="change-value"></input>/ 6
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="evaluation-table-wrapper">
              <div className="evaluation-table">
                <div className="table-header">
                  <div>1. Requirement 1 Title</div>
                  <div>Documents to Upload</div>
                  <div>Submission</div>
                </div>

                <div className="table-body">
                  <div className="column">
                    <p>Title in the content</p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur tempor, magna vel auctor ultricies, tortor nibh
                      fermentum lectus, sed eleifend orci lacus vel justo. Proin
                      suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                    </p>
                    <p>
                      Example of links here: Click{" "}
                      <a className="link" href="#">
                        here
                      </a>{" "}
                      to see more information
                    </p>
                  </div>

                  <div className="column">
                    <p>Title in the content</p>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur tempor, magna vel auctor ultricies, tortor nibh
                      fermentum lectus, sed eleifend orci lacus vel justo. Proin
                      suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                    </p>
                    <p>
                      Example of links here: Click{" "}
                      <a className="link" href="#">
                        here
                      </a>{" "}
                      to see more information
                    </p>
                  </div>

                  <div className="column submission">
                    <button className="upload-btn btn outline-btn ">Upload</button>

                    <div className="files">
                      <p>
                        <b>File Uploaded</b>
                      </p>
                      <p>
                        abc.xls <span>Delete</span>
                      </p>
                      <p>
                        def.xls <span>Delete</span>
                      </p>
                    </div>
                    <label>Comment</label>
                    <textarea placeholder=""></textarea>
                  </div>
                </div>

                <div className="status-bar">
                  <span>Status</span>
                  <span>Pending Review</span>
                </div>
                <div className="commant-box">
                  <label>Peer Reviewer/Final Approver Comments (Internal)</label>
                  <textarea placeholder="SGBC Comments"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div className="section-card mb-0 pb-0">
            <div className="commant-box">
              <label>Peer Reviewer Comment</label>
              <textarea className="mt-2"></textarea>
            </div>
            <div className="commant-box">
              <label>Approver Reviewer Comment</label>
              <textarea className="mt-2" disabled>
                {" "}
              </textarea>
            </div>
          </div>
        </div>
      </Accordion>
      <Accordion title="Certificate Grouping"
        className="mb-4"
        button={false}
        accordion={true}>
        <div className="certificate-grouping-list-page">
          <div className="crud-requirement-list">
            <div className="corporate-member-list">
              <div className="table-title mt-2">
                <h3>Model Grouping</h3>
              </div>
              <div className="member-list">
                <div className="content-section">
                  {/* Left Table */}
                  <div className="table-section">
                    <table>
                      <thead>
                        <tr>
                          <th>Brand Name</th>
                          <th>Model Name</th>
                          <th>Rating</th>
                          <th>Test Value</th>
                          <th>Cert Number</th>
                          <th>Cert Prefix</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Brand Name A</td>
                          <td>Model Name A</td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Brand Name A</td>
                          <td>Model Name A</td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Brand Name A</td>
                          <td>Model Name A</td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Brand Name A</td>
                          <td>Model Name A</td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                disabled
                              // value={poNumber}
                              // onChange={(e) => setPoNumber(e.target.value)}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="table-title mt-4">
                <h3>Cost Allocation</h3>
              </div>
              <div className="cost-allocation-list member-list">
                <div className="content-section">
                  {/* Left Table */}
                  <div className="table-section">
                    <table>
                      <thead>
                        <tr>
                          <th>Cert Number</th>
                          <th>Item Code</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>SGBP009</td>

                          <td>
                            <div disabled className="form-group">
                              <Select
                                className="custom-checkbox-select"
                                // value={props.value}
                                // value={""} /
                                // options={SGBP009options}

                                // onChange={props.onChange}
                                // onBlur={props.onBlur}
                                // options={props.options}
                                // isMulti={props.isMultiSelect}
                                // placeholder={props.placeholder}
                                isDisabled={true}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Brand Name A</td>

                          <td>
                            <div className="form-group">
                              <Select
                                className="custom-checkbox-select"
                                // value={props.value}
                                // value={""} /
                                // options={SGBP009options}

                                // onChange={props.onChange}
                                // onBlur={props.onBlur}
                                // options={props.options}
                                // isMulti={props.isMultiSelect}
                                // placeholder={props.placeholder}
                                isDisabled={true}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Brand Name A</td>

                          <td>
                            <div className="form-group">
                              <Select
                                className="custom-checkbox-select"
                                // value={props.value}
                                // value={""} /
                                // options={SGBP009options}

                                // onChange={props.onChange}
                                // onBlur={props.onBlur}
                                // options={props.options}
                                // isMulti={props.isMultiSelect}
                                // placeholder={props.placeholder}
                                isDisabled={true}
                              />

                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="table-title mt-5 mb-4">
                <h3>Internal Notes</h3>
              </div>
              <div className="mt-2">
                <label className="form-label">Comments from Case Officer</label>
                <textarea disabled
                  className="form-control mt-1"
                  rows="4"
                // value={internalNotes}
                // onChange={(e) => setInternalNotes(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>
          {/* Modal */}
          {/* <CenterModel
          show={showAcceptModal}
          handleClose={closeAcceptModal}
          modelTitle="Combine Invoice"
        >
          <label className="form-check-label" htmlFor="flexRadioDefault">
            Push to Xero
          </label>
          <div className="radio-group generate-invoice-model d-flex gap-4 mt-2 mb-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              // checked={isPoNumberRequired}
              // onChange={() => setIsPoNumberRequired(true)}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault1">
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault2"
              // checked={!isPoNumberRequired}
              // onChange={() => setIsPoNumberRequired(false)}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault2">
                No
              </label>
            </div>
          </div>
          <p>If No, please enter Manual Invoice Number</p>
          <input
            type="text"
            className="form-control mt-2"
          // value={poNumber}
          // onChange={(e) => setPoNumber(e.target.value)}
          />

          <div className="d-flex justify-content-center gap-2 mt-4">
            <Buttons
              buttonText="Submit"
              buttonTypeClassName="success-btn"
            // onClick={onApproveClick}
            />
          </div>
        </CenterModel> */}
        </div>
      </Accordion>

      <div className="d-flex justify-content-between mt-5">
        <Buttons
          buttonText="Back"
          buttonTypeClassName="black-btn"
        // onClick={handleCombine}
        // isLoading={isChangeKeyPosition}
        // isDisable={isChangeKeyPosition}
        />
        <div className="d-flex gap-3">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="success-btn"
          // onClick={handleCombine}
          // isLoading={isChangeKeyPosition}
          // isDisable={isChangeKeyPosition}
          />
        </div>
      </div>

      {/* Center Modal  */}

      {isModalOpen &&
        <CenterModel
          modelTitle={''}
          show={"test"}
          handleClose={openCloseModal}
          onUpload={openModal}
        >
          <div className="crud-requirement-list">
            <div className="corporate-member-list">
              <div className="sgbp-category">
                <div className="row w-100">
                  <div className="col-10 row">
                    <FormCreator ref={AuditlogRef} {...AuditlogData} />
                  </div>
                  <div className="col-2 audit-btn-group">
                    <Buttons
                      buttonText="Search"
                      buttonTypeClassName="search-btn "
                    // onClick={handleSearch}
                    />
                    <Buttons
                      buttonText="Clear"
                      buttonTypeClassName="btn btn-secondary"
                    // onClick={handleClearClick}
                    />
                  </div>
                </div>
              </div>

              <div className="audit-log-list">
                <MolGrid
                  ref={molGridRef}
                  configuration={AuditlogConfig}
                  // dataSource={dataSource}
                  allowPagination={true}
                // pagination={paginationRequest}
                // onPageChange={handlePageChange}
                // onActionChange={actionHandler}
                />
              </div>
            </div>
          </div>
        </CenterModel>
      }
    </div>

  );
};

export default ProductsApplicationDetails;
